export const GRAPHQL_VARIABLES = {
  filter: {
    _id: '5fc44a6984ffd06759c1a1e1'
  }
};

export const QUERY = `
  query invoicesOne ($filter: AutoFilledFilterFindOneinvoicesInput!, $skip: Int, $sort: SortFindOneinvoicesInput) {
    invoicesOne (filter: $filter, skip: $skip, sort: $sort) {
        companyId
        customerId
        status
        allowedPaymentTypes
        currency
        total
        paid
        amountDue
        amountPaid
        metadata
        bkInvoice
        _id
        updatedAt
        createdAt
    }
  }
`;
